// © Microsoft Corporation. All rights reserved.

import Clouds from "@msnews/icons-wc/icons/Clouds.svg";
import Community from "@msnews/icons-wc/icons/Community.svg";
import Globe from "@msnews/icons-wc/icons/Globe.svg";
import HamburgerMenuTraffic from "@msnews/icons-wc/icons/HamburgerMenuTraffic.svg";
import HomeV2 from "@msnews/icons-wc/icons/HomeV2.svg";
import Money from "@msnews/icons-wc/icons/Money.svg";
import News from "@msnews/icons-wc/icons/News.svg";
import Polls from "@msnews/icons-wc/icons/Polls.svg";
import Profile from "@msnews/icons-wc/icons/Profile.svg";
import Qna from "@msnews/icons-wc/icons/Qna.svg";
import Recipes from "@msnews/icons-wc/icons/Recipes.svg";
import Shopping from "@msnews/icons-wc/icons/Shopping.svg";
import Sports from "@msnews/icons-wc/icons/Sports.svg";
import Sun from "@msnews/icons-wc/icons/Sun.svg";
import Travel from "@msnews/icons-wc/icons/Travel.svg";

export const homeBrandIcon = `<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
<path d="M8.9975 2.38811C9.56767 1.87584 10.4323 1.87584 11.0025 2.38811L16.5025 7.32965C16.8191 7.61414 17 8.01977 17 8.44544V15.4996C17 16.328 16.3284 16.9996 15.5 16.9996H13C12.1716 16.9996 11.5 16.328 11.5 15.4996V11.9996C11.5 11.7234 11.2761 11.4996 11 11.4996H9C8.72386 11.4996 8.5 11.7234 8.5 11.9996V15.4996C8.5 16.328 7.82843 16.9996 7 16.9996H4.5C3.67157 16.9996 3 16.328 3 15.4996V8.44544C3 8.01977 3.18086 7.61414 3.4975 7.32965L8.9975 2.38811ZM10.3342 3.13197C10.1441 2.96122 9.85589 2.96122 9.66583 3.13197L4.16583 8.07351C4.06029 8.16834 4 8.30355 4 8.44544V15.4996C4 15.7757 4.22386 15.9996 4.5 15.9996H7C7.27614 15.9996 7.5 15.7757 7.5 15.4996V11.9996C7.5 11.1711 8.17157 10.4996 9 10.4996H11C11.8284 10.4996 12.5 11.1711 12.5 11.9996V15.4996C12.5 15.7757 12.7239 15.9996 13 15.9996H15.5C15.7761 15.9996 16 15.7757 16 15.4996V8.44544C16 8.30355 15.9397 8.16834 15.8342 8.07351L10.3342 3.13197Z" />
</svg>`;

export const IconMap = {
    homeV2: HomeV2,
    sun: Sun,
    globe: Globe,
    polls: Polls,
    news: News,
    sports: Sports,
    clouds: Clouds,
    shopping: Shopping,
    money: Money,
    traffic: HamburgerMenuTraffic,
    recipes: Recipes,
    qna: Qna,
    travel: Travel,
    profile: Profile,
    community: Community
};

export const homeNavItemId = "myfeed";

const bierstadtFontInfo = { name: "Bierstadt", url: "https://assets.msn.com/staticsb/statics/latest/fonts/bierstadt/bierstadt.woff2" };
const tenoriteFontInfo = { name: "Tenorite", url: "https://assets.msn.com/staticsb/statics/latest/fonts/tenorite/tenorite.woff2" };

export const verticalBrandingFontMap: { [key: string]: { name: string, url: string } } = {
    news: { name: "EB Garamond", url: "https://assets.msn.com/statics/fonts/eb-garamond-v14-latin-regular.woff2" },
    sports: { name: "Bahnschrift", url: "https://assets.msn.com/staticsb/statics/latest/fonts/bahnschrift/bahnschrift.woff2" },
    weather: bierstadtFontInfo,
    traffic: bierstadtFontInfo,
    finance: bierstadtFontInfo,
    travel: tenoriteFontInfo,
    recipes: tenoriteFontInfo,
    shopping: tenoriteFontInfo,
    qna: { name: "Lora", url: "https://assets.msn.com/staticsb/statics/latest/fonts/lora/lora-regular.woff2" }
};